import { Nullable } from 'constants/types'

interface IAnalyticsValue {
    name: string
    value: string | number
}

export class Article {
    public _id: Nullable<string>
    public get id(): Nullable<string> {
        return this._id
    }

    private analyticsValues: Array<IAnalyticsValue> = []

    public constructor(public el: HTMLElement) {
        this._id = el.getAttribute('data-article-id')
    }

    /**
     * Update the outerHTML string of the element with an analytics value
     */
    public setAnalyticsValue(key: string, value: string): void {
        const analyticsValue: IAnalyticsValue = {
            name: key,
            value: value
        }

        this.analyticsValues.push(analyticsValue)
    }

    /**
     * Get the outerHTML of the element, with analytics values injected
     */
    public getOuterHTML(): string {
        let dataEvtVal: string = this.el.getAttribute('data-evt-val') || ''
        if (dataEvtVal) {
            //apply the analytics values to the article html before returning
            this.analyticsValues.forEach((analyticsValue: IAnalyticsValue) => {
                dataEvtVal = dataEvtVal.replace(
                    '${ ' + analyticsValue['name'] + ' }',
                    analyticsValue['value'].toString()
                )
            })
            // get rid of attributes with empty string value
            const dataEvtValJson = JSON.parse(dataEvtVal)
            for (const attributeName in dataEvtValJson) {
                if (!dataEvtValJson[attributeName]) {
                    delete dataEvtValJson[attributeName]
                }
            }
            this.el.setAttribute('data-evt-val', JSON.stringify(dataEvtValJson))
            // Find every <a> anchor and append the itm_source or utm_source query param
            try {
                const anchors = this.el.querySelectorAll('a[href]')
                anchors.forEach((anchor) => {
                    const href = anchor.getAttribute('href')
                    if (href) {
                        const widgetNameValue =
                            this.analyticsValues.find(
                                (av) => av.name === 'list.widgetname'
                            )?.value || ''
                        if (widgetNameValue) {
                            const isExternalUrl =
                                /^https?:\/\//i.test(href) || // http:// or https://
                                /^\/\//.test(href) // protocol-relative (//)
                            const [base, query = ''] = href.split('?')
                            const param_name = isExternalUrl
                                ? 'utm_source'
                                : 'itm_source'
                            // append itm_source or utm_source if not already present
                            const params = new URLSearchParams(query)
                            if (!params.has(param_name)) {
                                params.append(
                                    param_name,
                                    widgetNameValue
                                        .toString()
                                        .toLowerCase()
                                        .replace(/\s+/g, '-')
                                )
                            }
                            const newHref = `${base}?${params.toString()}`
                            anchor.setAttribute('href', newHref)
                        }
                    }
                })
            } catch (err) {
                // ignore errors in anchor processing
            }
        }
        return this.el.outerHTML
    }
}
